<script lang="ts">
  import type { BlogPostsQuery } from '$lib/content-queries/generated/QueryBlogPosts'
  import cdnImageURL from 'src/utils/cdn'
  import { onMount } from 'svelte'
  import { fade } from 'svelte/transition'
  import SemanticDate from '../SemanticDate.svelte'
  import SkeletonBlock from '../ui/SkeletonBlock.svelte'

  export let post: BlogPostsQuery['posts'][0]
  const imageUrl = post.smallImage ? post.smallImage.url : post.heroImage.card

  let imgElement: HTMLImageElement
  let loadedImage = imgElement?.complete || false
  function imgLoaded() {
    loadedImage = true
  }

  onMount(() => {
    if (imgElement.complete) loadedImage = true
  })
</script>

<div class="flex flex-col items-start p-4 mx-auto text-left lg:p-0 md:max-w-md">
  <a href="/blog/{post.slug}" class="flex flex-col items-left mx-auto">
    <div class="relative">
      {#if !loadedImage}
        <div
          out:fade|local
          class="absolute inset-0 rounded-md object-center object-cover h-[280px] w-full"
        >
          <SkeletonBlock height="100%" borderRadius="3px" width="100%" />
        </div>
      {/if}
      <img
        src={cdnImageURL({ src: imageUrl, width: 360 })}
        alt={post.headline}
        width={360}
        height={280}
        bind:this={imgElement}
        on:load={imgLoaded}
        loading="lazy"
        class="rounded-md object-center object-cover h-[280px] w-full bg-slate-200"
      />
    </div>

    <p class="mt-4 text-xl font-semibold text-gray-900">{post.headline}</p>
    <p class="mt-3 text-base text-gray-500">{post.previewText}</p>
  </a>
  <div class="flex items-center mt-6">
    <div class="ml-0">
      <div class="flex space-x-1 text-sm text-gray-500">
        <SemanticDate date={post.historicalPublishedAt ?? post.publishedAt} dateStyle="medium" />
      </div>
    </div>
  </div>
</div>
